import { makeApiUrl } from '../helpers/makeApiUrl';
import { authHeader } from '../helpers/authHeader';
import { handleResponse } from '../helpers/handleResponse';

const clientUsers = (mfgId) => {
    const body = new FormData();
    body.append('mfgId', mfgId);
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body
    };

    return fetch(makeApiUrl('admin-tools/users', 'internal'), requestOptions)
        .then(handleResponse)
}
export const adminToolsService = {
    clientUsers
};